import { render } from "./drag_placeholder.vue?vue&type=template&id=4543e11b"
import script from "./drag_placeholder.vue?vue&type=script&lang=js"
export * from "./drag_placeholder.vue?vue&type=script&lang=js"

import exportComponent from "/app/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/template_builder/drag_placeholder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4543e11b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4543e11b', __exports__)) {
    api.reload('4543e11b', __exports__)
  }
  
  module.hot.accept("./drag_placeholder.vue?vue&type=template&id=4543e11b", () => {
    api.rerender('4543e11b', render)
  })

}


export default __exports__